import { Icon } from '@/legacy/components/Icon'
import { TextField } from '@/legacy/components/Input'

import { useSelectFieldEvent } from '@/legacy/core/analytics/hooks'

import { usePartnerSearch } from '../core/PartnerSearchContext'

const InputSearch = () => {
  const { handleSearchInput, handleKeyPressDown } = usePartnerSearch()
  const selectFieldEvent = useSelectFieldEvent()

  const handleEvent = () => {
    selectFieldEvent({ label: 'busque-pelo-parceiro' })
  }

  return (
    <TextField
      className="search-partner"
      onChange={handleSearchInput}
      placeholder="Busque pelo parceiro"
      aria-label="Busque por parceiros: Itau, Nubank..."
      onKeyDown={handleKeyPressDown}
      onClick={handleEvent}
    >
      <Icon icon="magnifier" width={24} height={24} aria-hidden className="icon__magnifier" />
    </TextField>
  )
}
export default InputSearch
